module.exports = __webpack_public_path__ + "img/profile-woman-12-min.a002c473.jpg";